import React from 'react';
import { Box, Typography, Grid, Divider, Link } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';

import { useNavigate } from 'react-router-dom';
import { Homeimages, projectbannerbg } from '../../../../../assets';
import FooterForm from '../../../../Footer/FooterForm';

interface FooterProps {
  projectTitle?: string;
  projectSlug?: string;
}

const DEFAULT_FOOTER_COPY =
  'Experts in Ultra-Luxury Real Estate, Delivering Iconic Homes Defined by Trust, Precision, and Prestige.';

const FOOTER_COPY: Record<string, string> = {
  'vibrant developers':
    'Hyderabad’s most discreet luxury address — Palatium, crafted with precision, proportion, and purpose.',
  'vibrant-developers-palatium':
    'Hyderabad’s most discreet luxury address — Palatium, crafted with precision, proportion, and purpose.',
  'prestige vaishnaoi rainbow waters':
    '  Rainbow Waters elevates Kokapet with resort-style waterfront living and hospitality-grade amenities.',
  'rainbow waters':
    ' Rainbow Waters elevates Kokapet with resort-style waterfront living and hospitality-grade amenities.',
  'prestige-vaishnaoi-rainbow-waters':
    ' Rainbow Waters elevates Kokapet with resort-style waterfront living and hospitality-grade amenities.',
  'acasa':
    'A refined high-rise sanctuary in Kokapet, thoughtfully designed for balance, privacy, and elevated living. Crafted with purpose, proportion, and a deep sense of well being Acasa is where luxury feels personal',
  megaleio:
    ' Megaleio’s twin towers at TGSPA Junction sculpt 13-foot volumes, private lift lobbies, and bespoke automation for the city’s tastemakers.',
  'navanaami megaleio':
    ' Megaleio’s twin towers at TGSPA Junction sculpt 13-foot volumes, private lift lobbies, and bespoke automation for the city’s tastemakers.',
  'navanaami-megaleio':
    ' Megaleio’s twin towers at TGSPA Junction sculpt 13-foot volumes, private lift lobbies, and bespoke automation for the city’s tastemakers.',
};

const getFooterCopy = (projectTitle?: string, projectSlug?: string) => {
  const normalizedTitle = projectTitle?.trim().toLowerCase();
  const normalizedSlug = projectSlug?.trim().toLowerCase();
  if (normalizedTitle && FOOTER_COPY[normalizedTitle]) {
    return FOOTER_COPY[normalizedTitle];
  }
  if (normalizedSlug && FOOTER_COPY[normalizedSlug]) {
    return FOOTER_COPY[normalizedSlug];
  }
  return DEFAULT_FOOTER_COPY;
};

const linksdata = [
  { title: 'Home', url: '/' },
  { title: 'About Us', url: '/about-us' },
  { title: 'Blogs', url: '/blogs' },
  { title: 'Contact Us', url: '/contactus' },
];

const Footer: React.FC<FooterProps> = ({ projectTitle, projectSlug }) => {
  const navigate = useNavigate();

  const socialLinks = [
    { Icon: FacebookIcon, url: 'https://www.facebook.com/williamsrajiv' },
    {
      Icon: XIcon,
      url: 'https://x.com/RajivCWilliams?t=2UnilCIJUvX9kQG1dAaXaw&s=09',
    },
    { Icon: InstagramIcon, url: 'https://www.instagram.com/williams_rajiv/' },
    { Icon: LinkedInIcon, url: 'https://www.linkedin.com/in/rajivwilliams/' },
    { Icon: YouTubeIcon, url: 'https://www.youtube.com/@rajiv-williams' },
  ];

  return (
    <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 'auto',
          backgroundImage: `url(${projectbannerbg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {/* Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(3, 59, 103, 0.7)',
            zIndex: 1,
          }}
        />

        {/* Content */}
        <Box
          sx={{ position: 'relative', zIndex: 2, color: 'white', px: 3, py: 6 }}
        >
          <Grid container spacing={6}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <img
                  src={Homeimages.rwsignlogo}
                  alt="Rajiv Williams signature logo"
                  width={50}
                  height={100}
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: 100,
                    userSelect: 'none',
                    marginBottom: '10px',
                  }}
                />
              </Box>
              <Typography
                variant="body2"
                sx={{ mt: 1, color: 'white', textAlign: 'start' }}
              >
                {getFooterCopy(projectTitle, projectSlug)}
              </Typography>

              {/* Social Icons */}
              <Box sx={{ display: 'flex', gap: 1, mt: 3 }}>
                {socialLinks.map(({ Icon, url }, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 40,
                      height: 40,
                      // bgcolor: '#222',
                      borderRadius: '50%',
                      cursor: 'pointer',
                      transition: '0.3s',
                      '&:hover': { bgcolor: '#444' },
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    onClick={() => window.open(url, '_blank')}
                  >
                    <Icon sx={{ color: 'white' }} />
                  </Box>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Typography
                variant="h6"
                fontWeight="600"
                gutterBottom
                sx={{
                  textAlign: { xs: 'start', md: 'center' },
                  color: 'white',
                }}
              >
                LINKS
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: { xs: 'start', md: 'center' },
                }}
              >
                <Box sx={{ width: 'fit-content' }}>
                  {linksdata.map((t) => (
                    <Box
                      key={t.title}
                      onClick={() => navigate(t.url)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        my: 1,
                        color: 'white',
                        '&:hover': { color: '#ccc' },
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          fontSize: '18px',
                          mr: 1,
                          lineHeight: 1,
                        }}
                      >
                        •
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{ textAlign: 'left', color: 'white' }}
                      >
                        {t.title}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={5}>
              <FooterForm />
            </Grid>
          </Grid>

          <Divider sx={{ my: 4, bgcolor: 'white' }} />

          <Typography
            variant="body2"
            sx={{ textAlign: 'center', color: 'white',mb:{xs:16,md:'auto'} }}
          >
            © {new Date().getFullYear()} <b>RAJIV WILLIAMS</b>. All rights
            reserved.Powered by{' '}
            <b>
              <Link
                href="https://dezignshark.com"
                target="_blank"
                sx={{
                  color: 'white',
                  textDecoration: 'none',
                  '&:hover': { color: '#ccc' },
                }}
              >
                Dezign Shark
              </Link>
            </b>
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: 'center', mt: 1 }}
          ></Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
